webpackJsonp([112399453350854],{

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(23);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _prismicDom = __webpack_require__(10);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _rebass = __webpack_require__(4);
	
	var _theme = __webpack_require__(13);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _components = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var determineColor = function determineColor(region) {
	  var color = "violet";
	  if (region === "update" || region === "institution" || region === null || region === undefined) {
	    color = "ash";
	  }
	  if (region === "middle-east-and-north-africa" || region === "oriente-medio-y-norte-de-africa" || region === "الشرق-الاوسط-وشمات-افريقيا") {
	    color = "orange";
	  }
	  if (region === "africa" || region === "africa1" || region === "افريقيا") {
	    color = "green";
	  }
	  if (region === "latin-america" || region === "america-latina-y-el-caribe" || region === "امريكا-اللاتينية") {
	    color = "blue";
	  }
	  if (region === "asia" || region === "asia1" || region === "اسيا") {
	    color = "pink";
	  }
	  if (region === "europe--central-asia" || region === "europa-y-asia-central" || region === "اوروبا-واسيا-الوسطى") {
	    color = "yellow";
	  }
	  return color;
	};
	
	var linkResolver = function linkResolver(doc) {
	  return "/" + doc.type;
	};
	
	var Update = function (_React$Component) {
	  _inherits(Update, _React$Component);
	
	  function Update() {
	    _classCallCheck(this, Update);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Update.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.data.page.alternate_languages) {
	      this.context.setAltLanguages(this.props.data.page.alternate_languages);
	    } else {
	      this.context.setAltLanguages(undefined);
	    }
	    document.body.style.background = _theme2.default.colors[determineColor(this.props.data.page.data.region.uid)];
	  };
	
	  Update.prototype.render = function render() {
	    var json = "";
	    if (this.props.data.page.raw) {
	      json = JSON.parse(this.props.data.page.raw);
	    }
	    if (this.props.data) {
	      return _react2.default.createElement(
	        "div",
	        {
	          style: this.props.transition ? this.props.transition.style : { opacity: 0 }
	        },
	        _react2.default.createElement(_components.Head, {
	          source: {
	            meta_title: [{
	              text: json.data.title !== undefined ? json.data.title[0] ? json.data.title[0].text + " | Bank Information Center" : "" : ""
	            }],
	            meta_description: [{
	              text: json.data.excerpt !== undefined ? json.data.excerpt[0] ? json.data.excerpt[0].text : "" : ""
	            }],
	            social_sharing_image: {
	              url: json.data.header_image !== undefined ? json.data.header_image.url : ""
	            }
	          }
	        }),
	        _react2.default.createElement(
	          _components.Main,
	          null,
	          _react2.default.createElement(
	            _components.PageHeader,
	            {
	              title: json.data.title[0].text,
	              color: json.data.region ? json.data.region.uid : json.uid,
	              image: json.data.header_image.url ? [json.data.header_image.url, json.data.header_image.half.url] : ""
	            },
	            json.data.description[0] && _react2.default.createElement(_components.Text, { children: json.data.description[0].text })
	          ),
	          _react2.default.createElement(
	            _components.PageSection,
	            null,
	            _react2.default.createElement(
	              _components.PageSidebar,
	              null,
	              this.props.data.author && _react2.default.createElement(_components.UpdateMeta, {
	                updateText: json.lang === "en-us" ? "Last update" : json.lang === "es-mx" ? "Última actualización" : "اخر تحديث",
	                attributionText: json.lang === "en-us" ? "Written by" : json.lang === "es-mx" ? "Escrito por" : "كتب بواسطة",
	                staffName: this.props.data.author.data.title[0] ? this.props.data.author.data.title[0].text : "",
	                staffImage: this.props.data.author.data.header_image.url ? this.props.data.author.data.header_image.quarter.url : "",
	                secondaryStaffName: this.props.data.secondary_author && this.props.data.secondary_author.data.title[0] ? this.props.data.secondary_author.data.title[0].text : "",
	                secondaryStaffImage: this.props.data.secondary_author && this.props.data.secondary_author.data.header_image.url ? this.props.data.secondary_author.data.header_image.quarter.url : "",
	                publishDate: json.data.publish_date ? (0, _moment2.default)(json.data.publish_date).format("MMMM Do, YYYY") : "",
	                updateDate: json.last_publication_date ? (0, _moment2.default)(json.last_publication_date).format("MMMM Do, YYYY") : "",
	                to: this.props.data.author.lang + "/team/" + this.props.data.author.uid,
	                secondaryTo: this.props.data.secondary_author ? this.props.data.author.lang + "/team/" + this.props.data.secondary_author.uid : ""
	              }),
	              _react2.default.createElement(
	                _rebass.Box,
	                { mt: 1 },
	                this.props.data.region && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.region.data.title[0].text,
	                  cardColor: determineColor(this.props.data.page.data.region.uid),
	                  to: "/" + json.lang + "/region/" + this.props.data.region.uid,
	                  type: "Region"
	                }),
	                this.props.data.institution && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.institution.data.title[0].text,
	                  cardColor: determineColor(this.props.data.institution.data.type),
	                  to: "/" + json.lang + "/institution/" + this.props.data.institution.uid,
	                  type: "Institution"
	                }),
	                this.props.data.institution2 && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.institution2.data.title[0].text,
	                  cardColor: determineColor(this.props.data.institution2.data.type),
	                  to: "/" + json.lang + "/institution/" + this.props.data.institution2.uid,
	                  type: json.lang === "en-us" ? "Institution" : json.lang === "es-mx" ? "Institucione" : "لمؤسسة"
	                }),
	                this.props.data.institution3 && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.institution3.data.title[0].text,
	                  cardColor: determineColor(this.props.data.institution3.data.type),
	                  to: "/" + json.lang + "/institution/" + this.props.data.institution3.uid,
	                  type: json.lang === "en-us" ? "Institution" : json.lang === "es-mx" ? "Institucione" : "لمؤسسة"
	                }),
	                this.props.data.project && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.project.data.title[0].text,
	                  cardColor: determineColor(this.props.data.page.data.region.uid),
	                  to: "/" + json.lang + "/project/" + this.props.data.project.uid,
	                  type: "Project"
	                }),
	                this.props.data.campaign && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.campaign.data.title[0].text,
	                  cardColor: determineColor(this.props.data.campaign.data.type),
	                  to: "/" + json.lang + "/campaign/" + this.props.data.campaign.uid,
	                  type: "Campaign"
	                }),
	                this.props.data.campaign2 && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.campaign2.data.title[0].text,
	                  cardColor: determineColor(this.props.data.campaign2.data.type),
	                  to: "/" + json.lang + "/campaign/" + this.props.data.campaign2.uid,
	                  type: json.lang === "en-us" ? "Campaign" : json.lang === "es-mx" ? "Campaña" : "حملة"
	                }),
	                this.props.data.campaign3 && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.campaign3.data.title[0].text,
	                  cardColor: determineColor(this.props.data.campaign3.data.type),
	                  to: "/" + json.lang + "/campaign/" + this.props.data.campaign3.uid,
	                  type: json.lang === "en-us" ? "Campaign" : json.lang === "es-mx" ? "Campaña" : "حملة"
	                }),
	                this.props.data.campaign4 && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.campaign4.data.title[0].text,
	                  cardColor: determineColor(this.props.data.campaign4.data.type),
	                  to: "/" + json.lang + "/campaign/" + this.props.data.campaign4.uid,
	                  type: json.lang === "en-us" ? "Campaign" : json.lang === "es-mx" ? "Campaña" : "حملة"
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _components.PageContent,
	              null,
	              _react2.default.createElement(
	                _rebass.Box,
	                { is: "article" },
	                json.data.body[0] && _react2.default.createElement(
	                  _rebass.Box,
	                  null,
	                  json.data.body.map(function (slice, index) {
	                    if (slice.slice_type === "text") {
	                      return _react2.default.createElement(_components.Article, {
	                        is: "div",
	                        dangerouslySetInnerHTML: {
	                          __html: _prismicDom.RichText.asHtml(slice.primary.text, linkResolver)
	                        }
	                      });
	                    }
	                    if (slice.slice_type === "image") {
	                      return _react2.default.createElement(_components.ImageSlice, {
	                        imageSet: [slice.primary.image.url, slice.primary.image.half.url, slice.primary.image.quarter.url],
	                        caption: slice.primary.caption,
	                        alt: slice.primary.image.alt
	                      });
	                    }
	                    if (slice.slice_type === "quote") {
	                      return _react2.default.createElement(_components.BlockQuote, {
	                        quote: slice.primary.quote[0] ? slice.primary.quote[0].text : "",
	                        attribution: slice.primary.name_of_the_author[0] ? slice.primary.name_of_the_author[0].text : ""
	                      });
	                    }
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _components.PageSection,
	            { column: "true", borderTop: "true" },
	            _react2.default.createElement(
	              _components.PageContent,
	              null,
	              _react2.default.createElement(_components.H2, { children: "More Updates", mb: 5, fontSize: [4, 5] }),
	              this.props.data.updates && _react2.default.createElement(
	                _components.CardLayout,
	                null,
	                this.props.data.updates.edges.slice(0, 4).map(function (update, index) {
	                  return _react2.default.createElement(_components.UpdateCard, {
	                    key: "update" + index,
	                    object: update.node
	                  });
	                })
	              )
	            )
	          )
	        )
	      );
	    } else {
	      return null;
	    }
	  };
	
	  return Update;
	}(_react2.default.Component);
	
	Update.contextTypes = {
	  setAltLanguages: _propTypes2.default.func
	};
	exports.default = Update;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-update-js-16963a5f7b2e2ca9297b.js